<template>
    <v-app class="main-body">
      <v-container>

        <v-layout>
        <v-flex xs12 max-width="660px">

    <div v-if="authenticated">
      <p class="txt">Logged In As: {{cust.Name}}</p>
      <v-autocomplete
      :items="sortedItems"
      v-model="selected"
      label="Type an Item Code"
      :autofocus=true
      :full-width=true
      :menu-props="{}"
      :readonly="false"
      @change="getItemDetail(selected)"
      @keyup.delete="selected=undefined"
      strict="false"
      spellcheck="false"
      >
      <template slot="no-data">
        <v-list-tile>
          <v-list-tile-title>
            <div id="no-matches">No Matches - if the item you are looking for isn't listed please contact us.</div>
          </v-list-tile-title>
        </v-list-tile>
      </template>
      <template
        slot="item"
        slot-scope="{item}"
      >
      <v-list-tile-content>
      <v-list-tile-title v-text="item.text"></v-list-tile-title>
      <v-list-tile-sub-title v-text="item.value.collection"></v-list-tile-sub-title>
      </v-list-tile-content>
      </template>

      </v-autocomplete>

      <div class="itemInfo" v-if="selected">
        <p id="disc" class="txt" v-if="item.Disc === 1">Discontinued</p>
        <p class="txt">{{item.ItemNo}} - {{item.Description}}</p>
        <!-- Non UK Customers -->
        <table v-if="custType !== 'UK'" width="100%">
          <tr><td>Collection:</td><td align="right">{{item.Collection}}</td></tr>
          <tr><td>Validity Date:</td><td align="right">{{ValidityDate}}</td></tr>
          <tr><td>Stock in England: </td><td align="right"><strong>{{item.UkFreeStk}}</strong></td></tr>
          <tr v-if="item.TfrFreeStk > 0"><td>Stock in Transit to England: <br><span>(1-2 Weeks Wait - Please Order to Reserve)</span></td><td align="right"><strong>{{item.TfrFreeStk}}</strong></td></tr>
          <tr><td>Stock in France:</td><td align="right"><strong>{{item.FrFreeStk}}</strong></td></tr>

          <tr v-if="collType === 'UKOnly' && item.Disc === 0"><td align="center" colspan="2">Further stocks available usually 2 -3 weeks lead time - <u>Please place an order </u><a href="mailto:export@galeriehome.co.uk">export@galeriehome.co.uk</a></td></tr>
          <tr v-if="collType === 'Export' && item.Disc === 0"><td align="center" colspan="2">Please Email <a href="mailto:export@galeriehome.co.uk">export@galeriehome.co.uk</a> for Further Stock Information</td></tr>
          <tr><td class="dateUpdate" colspan="3" v-if="stockUpdate.length>0">(last updated: {{stockUpdate}})</td></tr>
        </table>

        <!-- UK Customers -->
        <table v-if="custType === 'UK'" width="100%">
          <tr><td>Collection:</td><td align="right">{{item.Collection}}</td></tr>
          <tr><td>Validity Date:</td><td align="right">{{ValidityDate}}</td></tr>
          <tr><td>In Stock:</td><td align="right"><strong>{{item.UkFreeStk}}</strong></td></tr>
          <tr v-if="item.TfrFreeStk > 0"><td>Stock in Transit to Warehouse: <br><span>(1-2 Weeks Wait - <strong>Please Place an Order to Reserve</strong>)</span></td><td align="right"><strong>{{item.TfrFreeStk}}</strong></td></tr>
          <tr v-if="item.FrFreeStk > 0"><td>Stock Available 2-3 weeks: <br> <span><strong>(Please Place an Order to Reserve)</strong></span></td><td align="right"><strong>{{item.FrFreeStk}}</strong></td></tr>
          <tr v-if="collType === 'UKOnly' && item.Disc === 0"><td align="center" colspan="2">Further stocks are usually available with a 2-3 week lead time - <strong>Please place an order to ensure delivery </strong><span>Phone: +44 (0) 1892 700730</span></td></tr>
          <tr v-if="collType === 'Export' && item.Disc === 0"><td align="center" colspan="2">Please Phone: +44 (0) 1892 700730 for Further Stock Information</td></tr>
          <tr><td class="dateUpdate" colspan="3" v-if="stockUpdate.length>0">(last updated: {{stockUpdate}})</td></tr>
        </table>
        <div class="txtWarning">This stock checker is just an indicator of the stock levels and not a guarantee of availability and may consist of different batches.</div>
        <br>
        <div v-if="PosFmt.length > 0">Stock Coming In:-</div>
        <table width="100%" class="tblStriped" v-if="PosFmt.length > 0"><th>Quantity Expected</th><th>Date Expected to Arrive at Warehouse</th><th v-if="custType === 'Export'">Location</th>
        <tr v-for="po in PosFmt" :key=po._id>
          <td >{{po.FreeStk}}</td><td>{{po.ExpectedReceiptDate}}</td><td v-if="custType === 'Export'">{{po.LocationCode}}</td></tr>
          <tr><td class="dateUpdate" colspan="3" v-if="poUpdate.length>0">(last updated: {{poUpdate}})</td></tr>
        </table>
        <br>
        <img class="imgStyle" fluid v-if="item" :src="'https://www.galeriehome.co.uk/img/'+selected.ItemNo+'.jpg'"/>
<br>
<p class="txt datausage">The colour accuracy of the product images will vary from screen to screen and should not be relied upon.</p><p class="txt datausage" v-if="custType === 'UK' "> Please order a free of charge sample. <a href="mailto:samples@galeriehome.co.uk">samples@galeriehome.co.uk</a></p>
<p class="txt datausage"> Warning: A very small amount of data is continually being used even when you are inactive to check stock updates. If you are concerned about your data usage please log out or close your browser after use.</p>
      </div>
    </div>

    <span v-if="!authenticated">
      <br>
      <br>
     <h6> Welcome to the Galerie Stock Checker Please Log in Above.</h6>
<br>
<br>
     <h6> If You Are a Galerie Customer and Would Like to Register to Use This Website Please contact Our Sales Office
    </h6>
    </span>

  </v-flex>
        </v-layout>

      </v-container>

 </v-app>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
let moment = require('moment')
export default {
  name: 'home',
  computed: {
    ...mapGetters([
      'customers',
      'customerDetailHome',
      'collectionsLive',
      'item',
      'pos',
      'customerItems',
      'updated'
    ]),
    sortedItems () {
      let aa = []
      this.customerItems.forEach((e1) => {
        aa.push({ text: e1.ItemNo, value: { _id: e1._id, ItemNo: e1.ItemNo, collType: e1.Type, collection: e1.Collection } })
      })
      return aa
    },
    ValidityDate () {
      let d1 = moment(this.item.ValidityDate)
      return d1.format('Do MMMM YYYY')
    },
    poUpdate () {
      let d1 = []
      let datePo = ''
      d1 = this.updated.filter(filtered => filtered.Name === 'POs')
      if (d1.length > 0) {
        d1 = moment(d1[0].updatedDate)
        datePo = d1.format('Do MMMM YYYY HH:mm')
      }
      return datePo
    },
    stockUpdate () {
      let d1 = []
      let dateStock = ''
      d1 = this.updated.filter(filtered => filtered.Name === 'Stock')
      if (d1.length > 0) {
        d1 = moment(d1[0].updatedDate)
        dateStock = d1.format('Do MMMM YYYY HH:mm')
      }
      return dateStock
    },
    PosFmt () {
      let aa = []
      for (const po of this.pos) {
        let d1 = moment(po.ExpectedReceiptDate)
        let d2 = ''
        if (po.LocationCode === 'D') { d2 = 'UK' } else { d2 = 'France' }
        if (this.custType !== 'UK' || d2 !== 'France') {
          aa.push({ FreeStk: po.FreeStk, ExpectedReceiptDate: d1.format('Do MMMM YYYY'), LocationCode: d2 })
        }
      }
      return aa
    },
    custType () {
      let aa = ''
      if (this.customerDetailHome.Type === 'UK') { aa = 'UK' } else { aa = 'Export' }
      return aa
    }
  },
  data () {
    return {
      selected: null,
      collType: '',
      states: ['aa', 'bb'],
      model: null
    }
  },
  created () {
    this.getDetails()
  },
  mounted () {
    this.$store.dispatch('getUpdated').then((response) => {
      // return this.update
    })
    setInterval(() => {
      if (this.authenticated) {
        let a = this.updated
        this.$store.dispatch('getUpdated').then((response) => {
          if (a[0].updatedDate < response.data.updated[0].updatedDate || a[1].updatedDate < response.data.updated[1].updatedDate) {
            if (this.selected !== null & this.selected !== undefined) {
              this.getItemDetail(this.selected)
            }
          }
          // return this.update
        })
      }
    }, 60000)
  },
  watch: {
    '$route': 'getDetails'
  },
  methods: {
    ...mapActions([
    ]),
    getDetails () {
      if (this.authenticated) {
        this.$store.dispatch('getCustomerDetailHome', this.cust.Acc).then(() => {
          let cust1 = this.$store.state.customer.customerDetailHome
          let collections = []
          let allColls = []
          let matchedColls = []
          let unmatchedColls = []
          let allowedCollections = []
          this.$store.dispatch('getCollectionsLive').then(() => {
            // restricted customer
            if (cust1.Type === 'Restricted') {
              collections = cust1.CollectionsAllowed
              allColls = this.$store.state.collection.collectionsLive
            } else {
              // unrestricted customers
              collections = cust1.CollectionsDisallowed
              if (cust1.Type === 'EU') { allColls = this.collectionsLive.filter(filtered => filtered.Region !== 'UK') }
              if (cust1.Type === 'Export') { allColls = this.collectionsLive.filter(filtered => filtered.Region === 'EXPORT') }
              if (cust1.Type === 'UK') { allColls = this.collectionsLive }
            }
            collections.forEach((e1) => allColls.forEach((e2) => {
              if (e1 === e2._id) {
                matchedColls.push(e2)
              }
            }
            ))
            allColls.forEach((e1) => {
              let aa = matchedColls.findIndex((aa) => {
                return aa === e1
              })
              if (aa === -1) {
                unmatchedColls.push(e1)
              }
            })
            if (cust1.Type === 'Restricted') { allowedCollections = matchedColls } else { allowedCollections = unmatchedColls }
            return allowedCollections
          }).then(() => {
            this.$store.dispatch('getItems').then((response) => {
              let filteredItems = []
              let items = response.data.items
              items.filter(filtered => {
                for (const entry of allowedCollections) {
                  if (entry.Name === filtered.Collection) {
                    filteredItems.push({ _id: filtered._id, ItemNo: filtered.ItemNo, Collection: filtered.Collection, Type: entry.Region })
                    return
                  }
                }
              })

              allowedCollections.forEach((e1) => items.forEach((e2) => {
                if (e1.collection === e2.collection) {}
              }))
              this.$store.commit('GET_CUSTOMER_ITEMS', filteredItems)
            })
          })
        })
      }
    },
    getItemDetail (payload) {
      if (payload === undefined) { return }
      if (payload.collType === 'UK') { this.collType = 'UKOnly' } else { this.collType = 'Export' }
      this.$store.dispatch('getItem', payload).then((response) => {
        let itemNo = response.data.item.ItemNo
        this.$store.dispatch('getPos', itemNo)
        if (process.env.NODE_ENV === 'development') {
          console.log(process.env.NODE_ENV)
          console.log(process.env.VUE_APP_CALLBACK_URL)
        }
      })
    },
    pressEnter () {
      let aa = document.getElementsByClassName('v-list__tile__title')
      let cc = aa[0].innerHTML
      let bb = this.customerItems.filter(filtered => filtered.ItemNo === cc)
      let dd = { '_id': bb[0]._id, ItemNo: bb[0].ItemNo, collType: bb[0].collType, collection: bb[0].Collection }
      this.selected = dd
      document.getElementsByClassName('v-input__slot')[0].blur()
    }
  },
  components: {
  },
  props: ['auth', 'authenticated', 'custAdmin', 'cust']
}
</script>

<style>
  .v-input__slot {
    background-color:rgb(240, 240, 240)
  }
  a {
    cursor: pointer;
  }
  #disc {
    color: red;

  }
  .txt {
    text-align: center;
    font-size: 110%;
    margin-bottom: 5px;
  }
  .datausage {
    font-size: 14px;
    color:dimgray;
    margin-top: 20px;
  }
  .selectBox {
    max-width: 500px;
    height: 50px;
    font-size: 16px;
  }
  .itemInfo {
    font-size: 16px;
  }
    @media (max-width: 700px) {
    .itemInfo {
      font-size: 14px;
    }
    .container {
      padding: 8px !Important;
    }
    p {
      margin-bottom: 4px
    }
  }
  @media (max-width: 600px) {
    .itemInfo {
      font-size: 12px;
    }
    .container {
      padding: 6px !Important;
    }
    p {
      margin-bottom: 2px
    }
  }
  .txtWarning {
    font-weight: bold;
    text-align: center;
  }
  td span {
    font-size: 75%
  }
  .imgStyle {
    width: 100%
  }
  .dateUpdate {
    font-size: 70%;
    text-align: center
  }
  #no-matches {
    font-size: 80%;
    text-align: center
  }

</style>
